import { Card } from 'react-bootstrap';
import RouteDeadlinesChart from './RouteDeadlinesChart';
import { useTranslation } from 'react-i18next';
//import RouteDeadlinesChart from './RouteDeadlinesChart';

const RouteDeadLinersCard = () => {
	const { t } = useTranslation();
	const tt = (key: string) => t(key, { ns: 'translation' });

	return (
		<Card className="h-100">
			<Card.Body className='card-body-chart'>
				<div className="d-flex justify-content-between">
					<div>
						<h5 className="ps-3">
							{tt('pages.thermography.cards.routeDeadlinesTitle')}
						</h5>
					</div>

				</div>
				<div className="d-flex justify-content-center">
					<RouteDeadlinesChart />
				</div>
			</Card.Body>
		</Card>
	);
};

export default RouteDeadLinersCard;
